import React from "react";
import { InteractiveButton } from "../../InteractiveButton.jsx";
import { useProductFollow } from "./hooks/use-product-follow.js";
import { SVG_HEART_MASK_IMAGE_BASE64 } from "../../../../interactive-images.js";

export const LikeProductButton = ({ followingRequestBody, productUid }) => {
	const { following, isButtonDisabled, performFollowRequest, buttonTitle } =
		useProductFollow({
			productUid,
			followingRequestBody,
		});

	const handleButtonClick = (event) => {
		event.stopPropagation();
		performFollowRequest();
	};

	return (
		<InteractiveButton
			colorful
			colorfulActive={following}
			onClick={handleButtonClick}
			disabled={isButtonDisabled}
			maskImageSrc={SVG_HEART_MASK_IMAGE_BASE64}
			title={buttonTitle}
		/>
	);
};
